import { atom } from "recoil";

export const activeCourseAtom = atom({
  key: "activeCourseAtom",
  default: null,
});
